import NextLink from "next/link";
import { Link, Text, List, ListItem } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { InsertLink } from "@airhelp/icons";

interface ListItemTypes {
  url: string;
  anchorText: string;
}

export interface LinkBoxProps {
  linkItems: ListItemTypes[];
}

const LinkBox = ({ linkItems, sbEditable }: SbEditableComponentProps<LinkBoxProps>) => (
  <List {...sbEditable}>
    {linkItems.map(({ url, anchorText }) => (
      <ListItem key={url} my={2}>
        <Link as={NextLink} href={url} passHref color="primary.500" fontSize="lg" display="flex" alignItems="center">
          <InsertLink />
          <Text ml={4}>{anchorText}</Text>
        </Link>
      </ListItem>
    ))}
  </List>
);

export default LinkBox;
